module.exports = (__webpack_require__(12))(49);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/large_image/web_client/views/imageViewerWidget/geojs.js from dll-reference girder_plugin_large_image
// module id = 133
// module chunks = 0